import dynamic from 'next/dynamic'
import type { ErrorPageWithRetryProps } from './ErrorPageWithRetry'

export const ErrorPageWithRetryDynamic = dynamic<ErrorPageWithRetryProps>(() =>
  import('./ErrorPageWithRetry').then((m) => m.ErrorPageWithRetry),
)

export type { ErrorPageWithRetryProps }
